import DoubleRow from './DoubleRow';

import classes from './scdotPdfReport.module.css';

interface Props {
  title: string;
  rows: any[][];
}

const DoubleSection = ({ title, rows }: Props) => {
  return (
    <div className={classes.doubleSectionContainer}>
      <div className={classes.tableWrapper}>
        <table>
          <thead>
            <tr>
              <th>{title}</th>
              <th />
              <th />
              <th />
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <DoubleRow key={index + title} row={row} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DoubleSection;
